<template>
  <div class="filter">
    <div class="label-title mb-3">
      {{ $t('view-Search.filter-title.users') }}
    </div>
    <div>
      <div>
        <range-input
          ref="users-slider"
          v-model="users"
          :data="{'1000': '1K', '10000': '10K', '50000': '50K', '500000': '500K', '1000000': '1M'}"
          :contained="true"
          tooltip="always"
          :dot-size="16"
        />
      </div>
      <div class="mt-5 influencer-size-wrapper">
        <b-form-select
          :options="influencerSize"
          :value="userSize"
          class="influencer-size"
          @change="handleUsersSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/scss/vue-slider.scss'
import VueSlider from 'vue-slider-component'

export default {
  components: {
    'range-input': VueSlider
  },
  props: {
    value: {
      type: Array,
      default: null
    }
  },
  computed: {
    users: {
      get () {
        const result = this.value ? [...this.value] : [undefined, undefined]

        if (result[0] === undefined) {
          result[0] = '1000'
        }
        if (!result[1]) {
          result[1] = '1000000'
        }

        return result
      },
      set (value) {
        const min = value[0] === '1000' && value[1] === '1000' ? null : value[0]
        const max = value[0] === '1000000' && value[1] === '1000000' ? null : value[1]

        this.$emit('input', [min, max])
      }
    },
    userSize () {
      const result = [this.users[0], this.users[1]]
      if (this.influencerSize.find(i => i.value && i.value.join() === result.join())) {
        return result
      }

      return null
    },
    influencerSize () {
      return [
        { value: null, text: this.$t('view-Search.influencer-size'), disabled: true },
        { value: ['1000', '10000'], text: 'Nano-influencer' },
        { value: ['10000', '50000'], text: 'Micro-influencer' },
        { value: ['50000', '500000'], text: 'Medium-influencer' },
        { value: ['500000', '1000000'], text: 'Macro-influencer' },
        { value: ['1000000', '1000000'], text: 'Mega-influencer' }
      ]
    }
  },
  mounted () {
    const element = this.$el.querySelector('.influencer-size-wrapper')
    element.style.setProperty('--bg-image', `url(${this.$publicPath}img/search-icon/star.svg)`)
  },
  methods: {
    handleUsersSizeChange (value) {
      this.$refs['users-slider'].setValue(value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .influencer-size-wrapper {
    position: relative;
    &:before {
      content: '';
      display: inline-block;
      position: absolute;
      background-repeat: no-repeat;
      background-position: center;
      background-image: var(--bg-image);
      width: 35px;
      height: 100%;
    }
  }
  .influencer-size {
    padding-left: 1.75rem;
  }
  ::v-deep {
    &.custom-select {
      border: none;
      background: #fff url("/img/search-icon/order-bottom.svg") right 0.75rem center no-repeat;
      cursor: pointer;
      &:focus {
        box-shadow: none;
      }
    }
  }
</style>
